export const updateLogoRoute = '/employer/logo/';
export const updateEnterpriseLogoRoute = '/enterprise/logo/';
export const updateEmployerLogoRoute = '/employer/logo/';
export const updateEmployerProfileRoute = '/employer/profile/update/';
export const updateEnterpriseCompanyResponsesRoute = '/enterprise/update-response/';
export const updateEmployerProfilePersonalRoute =
  '/employer/profile/personal/update/';
export const updateStatusRoute = '/updatestatus/';
export const updateWalkthroughStatusRoute = '/walkthrough/status/';
export const updateEmployerAlertsRoute = '/employer/profile/update/alerts/';
export const updateJobStatusCouponRoute = '/employer/coupan_code/jobs/update/';
export const updateApplicantAlertsRoute = '/applicants/account/alerts/';
export const changePasswordRoute = '/login/change-password/';
export const postReferralLinkRoute = '/employer/referrals/send/';
export const getAllUsersRoute = '/employer/subusers/get/';
export const enableUserRoute = '/employer/subusers/enable/';
export const createInviteLinkRoute = '/employer/subusers/link/';
export const createReviewRequestRoute = '/employer/review/request/';
export const addSubUsersRoute = '/employer/subusers/add/';
export const updateSubUsersRoute = '/employer/subusers/update/';
export const updateSubUsersPermissionsRoute =
  '/employer/subusers/permissions/edit/';
export const updateApplicantResumeProfileRoute = '/applicants/resume/profile/';
export const enterpriseProfileEditRoute = '/enterprise/profile/edit/';
export const enterpriseProfileImagesEditRoute = '/enterprise/profile/edit/images/';
export const updateSocialImageLogoRoute = '/enterprise/social_image/';
